export default __webpack_public_path__ + "static/Olivia-060965ddc578c6cf74bc1a44e0a9ed98.jpeg";